import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useCargoTypes } from '../../hooks';
import type { CargoType, CargoTypeFilters } from '../../models';

export interface CargoTypeFieldProps extends Omit<SelectProps<CargoType>, 'options'> {
  defaultFilters?: Partial<CargoTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<CargoType>['errorMessage'];
  isInvalid?: boolean;
}

export const CargoTypeField: React.FC<CargoTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useCargoTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
